import React from 'react';

const truncate = (value, max = 120) => {
    if (!value) return '—';
    return value.length > max ? `${value.slice(0, max)}…` : value;
};

const parseTags = (value) => {
    if (!value) return null;
    try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed) && parsed.length > 0 && parsed.every((tag) => tag && typeof tag === 'object' && 'label' in tag)) {
            return parsed;
        }
    } catch (err) {
        // Not JSON — treat as plain text below.
    }
    return null;
};

const HistoryValueCell = ({ value }) => {
    if (!value) return <span>—</span>;

    const tags = parseTags(value);
    if (tags) {
        return (
            <div className="d-flex flex-wrap gap-1">
                {tags.map((tag, idx) => (
                    <span
                        key={idx}
                        className="badge"
                        style={{
                            backgroundColor: tag.color || '#6c757d',
                            color: 'white',
                            fontSize: '0.75rem',
                            padding: '3px 8px',
                            borderRadius: '10px',
                            fontWeight: 600,
                        }}
                    >
                        {tag.label}
                    </span>
                ))}
            </div>
        );
    }

    return <span title={value}>{truncate(value)}</span>;
};

export default HistoryValueCell;
